import Rails from "@rails/ujs";

function populate_preview() {
  if (!document.getElementById('prescription_preview')) {
    return
  }
  let medicine_mode_button = document.getElementById('switch-medicine-mode')
  var unit_text = medicine_mode_button && medicine_mode_button.textContent.includes("饮片") ? "袋" : "g"
  var names = document.getElementsByClassName('prescription-medicine-name')
  var amounts = document.getElementsByClassName('prescription-medicine-amount')
  var preview = '<i>';
  var names_arr = []
  for (var i = 0, count = 0; i < names.length; i++) {
    if (names[i].value) {
      names_arr.push(names[i].value)
      preview += '<span class="medicine-chip">' + names[i].value + amounts[i].value + unit_text + '</span> '
      if (count % 4 == 3) {
        preview += "<br>"
      }
      count++;
    }
  }
  preview += '</i>'

  document.getElementById('prescription_preview').innerHTML = preview

  // find anti patterns
  let names_str = names_arr.join(',');
  Rails.ajax({
    type: 'GET',
    url: "/anti_patterns/find?medicine_names=" + names_str,
    success: (result) => {
      for (var i = 0; i < result.length; i++) {
        let anti_pattern_str = '<br><p style="color:red;">配药禁忌：' + result[i].name +
          ' (' + result[i].group1.join(',') + '), (' +
          result[i].group2.join(',') + ')</p>';
        preview += anti_pattern_str
        document.getElementById('prescription_preview').innerHTML = preview
      }
    }
  });

}
$(document).on('change paste keyup',
  '.prescription-medicine-amount, .prescription-medicine-name',
  populate_preview);

$(document).on('click', '.remove_fields', function () {
  setTimeout(populate_preview, 10)
});

$(document).on('click', '#use_preset_button', function () {
  setTimeout(populate_preview, 100)
});

$(document).on('click', '#switch-medicine-mode', function () {
  setTimeout(populate_preview, 10)
});

document.addEventListener("turbolinks:load", populate_preview);